module.exports = __webpack_public_path__ + "static/img/blue_03_514.bcae474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/blue_03_514.png
// module id = QYIH
// module chunks = 0